import { Col, Container, Form, Row } from 'react-bootstrap';
// import UpdateForm from '../components/UpdateForm';
import axios from 'axios';
import { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import Payment from '../components/Payment';
import { root_url } from '../setting';

const Search = ({ history }) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();
  const [joiner, setJoiner] = useState({});
  const [runners, setRunners] = useState({});
  const [res, setRes] = useState({});
  const [ticketInfo, setTicketInfo] = useState([]);
  const [showPayment, setShowPayment] = useState(false);
  const [ticketCode, setTicketCode] = useState('1');

  useEffect(() => {
    axios({
      method: 'get',
      url: `${root_url}/api/join/ticket-info`,
    })
      .then((res) => {
        if (res.status === 200) {
          let { data } = res;
          console.log(data);
          // const ticketType = pathname.split('/')[2];
          // console.log('ticketType: ' + ticketType);
          setTicketInfo(data);
        }
      })
      .catch((e) => {
        console.error(e);
      });
  }, []);
  const onSubmit = (inputData) => {
    //1. 이름, 전화번호, 접수번호가 모두 입력되어있는지 확인한다.
    //2. 서버에서 접수번호로 데이터를 받아온다. tickets 정보도 받아온다. (Payment에서 필요로 하기 때문)
    //3. 입력값과 일치한다면 Payment를 보여주어 수정, 결제, 취소, 확인 등을 할 수 있도록 한다.
    let { name, cellphone, reservationNumber } = inputData;
    console.log(reservationNumber);
    console.log(name);
    axios({
      method: 'post',
      url: `${root_url}/api/application/search`,
      data: {
        joinSeq: reservationNumber,
        joinerName: name,
        cellphone: cellphone,
      },
      headers: { 'Content-Type': 'application/json' },
    })
      .then((res) => {
        const { joiner, runners } = res.data;
        console.log(res);
        let joinVO = { joiner: joiner, runner: runners[0], runners: runners };
        setRes(joinVO);
        setJoiner(joiner);
        setRunners(runners);
        setShowPayment(true);
      })
      .catch((e) => {
        //error메시지가 있다면 보여줘야함
        if (e.response === undefined) {
          alert('시스템 서비스가 원할하지 않습니다. 관리자에게 문의하세요. (code - A0001)');
        } else {
          if (e?.response?.data?.errorCode === 'S0001') {
            // 해당 정보로 신청 정보가 없는 경우
            const msgObj = JSON.parse(e.response.data.errorMessage);
            alert(msgObj.message);
          } else {
            alert(e.response.data.errorMessage);
          }
        }
      });
  };
  // TODO

  return showPayment ? (
    <Payment
      setRes={setRes}
      res={res}
      ticketInfo={ticketInfo}
      history={history}
      title="신청 조회 및 수정"
      isFromSearch={true}
    />
  ) : (
    <Container>
      <h1 className="mt-3 mb-5">신청 조회 및 수정</h1>
      <form onSubmit={handleSubmit(onSubmit)}>
        <Form.Group controlId="formName" className="mt-3 mb-5">
          <Form.Label>이름</Form.Label>
          {/* <Form.Control
            type="text"
            placeholder="홍길동"
            value={name}
            onChange={onChangeName}
          /> */}
          <input
            type="text"
            className="form-in-class"
            placeholder="홍길동"
            {...register('name', {
              required: true,
              maxLength: 50,
              pattern: /^[A-Z|a-z|가-힣]{2,50}$/g,
            })}
          />
          {errors.name && (
            <span className="position-absolute" style={{ fontSize: '0.8rem', color: 'red' }}>
              (필수)이름을 공백없이 제대로 입력했나 확인해주세요.
            </span>
          )}
        </Form.Group>
        <Form.Group controlId="formPhoneNumber" className="mt-3 mb-5">
          <Form.Label>전화번호</Form.Label>
          {/* <Form.Control
            type="number"
            placeholder="01012345678(-없이 입력)"
            value={phoneNum}
            onChange={onChangePhoneNum}
            onKeyPress={onPressPhoneNum}
          /> */}
          <input
            type="number"
            className="form-in-class"
            placeholder="01012345678"
            {...register('cellphone', {
              required: true,
              maxLength: 11,
              pattern: /^[0-9]{4,11}/g,
            })}
          />
          {errors.cellphone && (
            <span className="position-absolute" style={{ fontSize: '0.8rem', color: 'red' }}>
              (필수)전화번호는 4자 이상, 11자 이하의 숫자만 입력해주세요.
            </span>
          )}
        </Form.Group>
        <Form.Group controlId="formReserveNumber" className="mt-3 mb-5">
          <Form.Label>접수번호</Form.Label>
          {/* <Form.Control
            type="text"
            placeholder="23"
            value={reservationNumber}
            onChange={onChangeReservationNumber}
          /> */}
          <Row>
            {/* <Col xs={{ span: 3 }}>
              <select onChange={(e) => setTicketCode(e.target.value)}>
                <option value="1">1(하프/미니)</option> */}
            {/* <option value="3">3(언텍트M)</option> */}
            {/* <option value="5">5(언텍트 트레킹)</option> */}
            {/* </select>
            </Col> */}
            {/* <Col xs={{ span: 1 }}>
              <span
                style={{
                  lineHeight: "2rem",
                  fontWeight: "bold",
                  fontSize: "1rem",
                }}
              >
                −
              </span>
            </Col> */}
            <Col>
              <input
                type="number"
                placeholder="1001"
                className="form-in-class"
                {...register('reservationNumber', {
                  required: true,
                  maxLength: 4,
                  pattern: /^[0-9]{4,4}/g,
                })}
              />
              {errors.reservationNumber && (
                <span className="position-absolute" style={{ fontSize: '0.8rem', color: 'red' }}>
                  (필수)접수번호는 4자리 숫자로 입력해주세요
                </span>
              )}
            </Col>
          </Row>
        </Form.Group>
        <input
          type="submit"
          className="bg-custom-color p-2 rounded text-white mb-5"
          style={{ border: 'none' }}
          value="신청 조회하기"
        />
      </form>
    </Container>
  );
};

export default Search;
